import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { IAnalisePerfil } from "../../commons/types/analisePerfil";
import logoStato from '../../assets/STATO-INTOO-LOGO-MY-INTOO-VERS-1.png';

// Interface para os serviços necessários
interface ExportPPCServices {
    analisePerfisActions: any;
    ppcCompetenciasActions: any;
    faixaSalarialActions: any;
}

export async function exportPPC(
    id: string, 
    methods: any, 
    translate: any,
    services: ExportPPCServices
) {
    try {
        // Usar os serviços passados como parâmetros
        const { ppcCompetenciasActions, faixaSalarialActions, analisePerfisActions } = services;

        // Obter dados do formulário
        const formData = methods.getValues() as IAnalisePerfil;

        // Obter o ID do contato
        const contatoId = formData.contatoId || id;

        // Variável para armazenar as faixas salariais localmente
        let faixasSalariais: any[] = [];

        try {
            // Verificar se o idFaixaRemuneracao está definido, se não estiver, buscar do servidor
            if (formData.idFaixaRemuneracao === undefined) {
                console.log('idFaixaRemuneracao está undefined, buscando dados atualizados do servidor');
                try {
                    // Buscar perfil atualizado do servidor
                    const perfilList = await analisePerfisActions.list(false, `?contatoId=${contatoId}`);
                    if (perfilList && perfilList.length > 0) {
                        // Atualizar o formData com os dados do servidor
                        if (perfilList[0].idFaixaRemuneracao !== undefined) {
                            formData.idFaixaRemuneracao = perfilList[0].idFaixaRemuneracao;
                            console.log('idFaixaRemuneracao atualizado com sucesso:', formData.idFaixaRemuneracao);
                        }
                    }
                } catch (perfilError) {
                    console.error('Erro ao buscar perfil atualizado:', perfilError);
                }
            }

            // Fazer chamada à API para obter os dados de resultadosRealizacoesCompetencias
            const realizacoesData = await ppcCompetenciasActions.list(false, `?IdContatoPerfilPlanejamento=${formData.id}`);
            // Carregar faixas salariais antes de gerar o PDF
            const faixasSalariaisData = await faixaSalarialActions.list();
            faixasSalariais = faixasSalariaisData;
            // Adicionar os dados ao formData
            formData.resultadosRealizacoesCompetencias = realizacoesData;
            console.log('Dados de realizações carregados com sucesso:', realizacoesData.length, 'itens');
        } catch (error) {
            console.error('Erro ao carregar dados:', error);
            // Continuar com a geração do PDF mesmo se não conseguir carregar os dados
        }

        console.log('Dados do formulário para PDF:', formData);

        // Criar um novo documento PDF
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Configurações de texto
        const titleSize = 18;
        const subtitleSize = 14;
        const questionSize = 11;
        const answerSize = 10;
        const margin = 15;
        const lineHeight = 7;

        // Função para adicionar elementos visuais a cada página
        const addPageDecorations = () => {
            const headerHeight = 20;

            // Adicionar logo (favicon) no cabeçalho
            try {
                // Ajusta o tamanho para manter a proporção adequada (24x18)
                const logoWidth = 28;
                const logoHeight = 22;
                const logoX = pdf.internal.pageSize.width - margin - logoWidth + 10;
                const logoY = headerHeight / 2 + 3 - logoHeight / 2;
                pdf.addImage(logoStato, 'png', logoX, logoY, logoWidth, logoHeight);
            } catch (error) {
                // Fallback para texto caso a imagem não possa ser carregada
                console.error('Erro ao carregar o logo:', error);
                pdf.setTextColor(255, 255, 255);
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(16);
                pdf.text('STATO', margin, headerHeight / 2 + 3, { align: 'left' });
            }

            // Adicionar borda decorativa na página
            pdf.setDrawColor(77, 189, 41); // Verde
            pdf.setLineWidth(0.5);
            pdf.rect(margin - 5, headerHeight + 5, pageWidth - (margin - 5) * 2, pageHeight - headerHeight - margin - 5);

            // Adicionar uma segunda borda interna com cor azul
            pdf.setDrawColor(0, 139, 255); // Azul
            pdf.setLineWidth(0.2);
            pdf.rect(margin - 3, headerHeight + 7, pageWidth - (margin - 3) * 2, pageHeight - headerHeight - margin - 9);

            // Adicionar rodapé
            pdf.setDrawColor(77, 189, 41); // Verde
            pdf.setLineWidth(0.5);
            pdf.line(margin, pageHeight - margin, pageWidth - margin, pageHeight - margin);

            pdf.setFont('helvetica', 'italic');
            pdf.setFontSize(8);
            pdf.setTextColor(100, 100, 100);
            pdf.text('Análise de Perfil e Planejamento de Carreira - STATO', pageWidth / 2, pageHeight - margin + 5, { align: 'center' });

            // Ajustar a posição inicial do conteúdo para começar abaixo do cabeçalho
            return headerHeight + 15;
        };

        // Função para adicionar texto com quebra de linha
        // Retorna a nova posição Y e informações sobre texto restante
        const addWrappedText = (text: string, x: number, y: number, maxWidth: number, size: number, isBold: boolean = false, maxHeight: number = -1): { newY: number, remainingText: string | null } => {
            if (!text || text.trim() === '') return { newY: y, remainingText: null };

            pdf.setFontSize(size);
            pdf.setFont('helvetica', isBold ? 'bold' : 'normal');

            // Dividir o texto em linhas
            const allLines = pdf.splitTextToSize(text, maxWidth);
            
            // Se não há limite de altura ou se o texto cabe inteiro, renderizar tudo
            if (maxHeight <= 0 || y + (allLines.length * (size * 0.35)) <= pageHeight - margin) {
                pdf.text(allLines, x, y);
                return { newY: y + (allLines.length * (size * 0.35)), remainingText: null };
            }
            
            // Calcular quantas linhas cabem na altura disponível
            const availableHeight = pageHeight - margin - y;
            const maxLines = Math.floor(availableHeight / (size * 0.35));
            
            // Garantir que pelo menos uma linha seja exibida
            const linesToRender = allLines.slice(0, Math.max(1, maxLines));
            pdf.text(linesToRender, x, y);
            
            // Verificar se há texto restante
            if (linesToRender.length < allLines.length) {
                const remainingLines = allLines.slice(linesToRender.length);
                return { newY: y + (linesToRender.length * (size * 0.35)), remainingText: remainingLines.join(' ') };
            }
            
            return { newY: y + (linesToRender.length * (size * 0.35)), remainingText: null };
        };

        // Função para verificar se precisa de nova página
        // Considera as bordas decorativas para não ultrapassar os limites
        const checkForNewPage = (currentY: number, neededSpace: number): number => {
            // Ajustar a margem inferior para considerar as bordas decorativas
            const bottomMargin = margin + 10; // Adicionar 10 pontos para garantir que não ultrapasse as bordas
            
            if (currentY + neededSpace > pageHeight - bottomMargin) {
                pdf.addPage();
                // Adicionar elementos visuais à nova página
                addPageDecorations();
                return margin + 30; // Ajustar para começar abaixo do cabeçalho
            }
            return currentY;
        };
        
        // Função para processar texto que pode precisar de várias páginas
        const processMultiPageText = (text: string, x: number, y: number, maxWidth: number, size: number, isBold: boolean = false): number => {
            let currentY = y;
            let remainingText: string | null = text;
            
            while (remainingText) {
                // Verificar se estamos perto do fim da página
                const availableHeight = pageHeight - margin - currentY;
                
                // Adicionar texto com limite de altura
                const result = addWrappedText(remainingText, x, currentY, maxWidth, size, isBold, availableHeight);
                currentY = result.newY;
                remainingText = result.remainingText;
                
                // Se ainda há texto e estamos perto do fim da página, criar nova página
                if (remainingText) {
                    pdf.addPage();
                    // Adicionar elementos visuais à nova página
                    addPageDecorations();
                    currentY = margin + 30; // Ajustar para começar abaixo do cabeçalho
                }
            }
            
            return currentY;
        };

        // Função para formatar nomes de campos
        const formatFieldName = (fieldName: string): string => {
            // Remover prefixo comum (ex: informacaoGeralP1 -> P1)
            let formatted = fieldName
                .replace(/^informacaoGeral/, 'Informação Geral ')
                .replace(/^analiseSwotForte/, 'Análise SWOT (Forte) ')
                .replace(/^analiseSwotFraco/, 'Análise SWOT (Fraco) ')
                .replace(/^analiseSwotOportunidade/, 'Análise SWOT (Oportunidade) ')
                .replace(/^analiseSwotAmeaca/, 'Análise SWOT (Ameaça) ');

            // Adicionar espaços entre camelCase
            formatted = formatted
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, str => str.toUpperCase())
                .trim();

            return formatted;
        };

        // Adicionar elementos visuais à primeira página
        addPageDecorations();

        // Inicializar a posição Y para começar abaixo do cabeçalho
        let yPosition = 40; // Posição inicial após o cabeçalho

        // Adicionar título principal ao PDF
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(titleSize);
        pdf.setTextColor(0, 0, 0); // Garantir que o texto seja preto
        pdf.text(translate('analiseDePerfilPlanejamentoCarreira'), pageWidth / 2, yPosition, { align: 'center' });
        yPosition += titleSize * 0.5;

        // Adicionar linha separadora
        pdf.setDrawColor(0);
        pdf.line(margin, yPosition + 2, pageWidth - margin, yPosition + 2);
        yPosition += lineHeight * 2;

        // Mapeamento de campos por seção
        const sections = [
            {
                title: `${translate('informacoesGeraisTitulo')} (Etapa 1)`,
                fields: [
                    'informacaoGeralP1', 'informacaoGeralP2', 'idFaixaRemuneracao',
                    'informacaoGeralP3', 'informacaoGeralP4', 'informacaoGeralP5',
                    'informacaoGeralP6', 'informacaoGeralP7', 'informacaoGeralP8',
                    'informacaoGeralP9', 'informacaoGeralP10', 'informacaoGeralP11',
                    'informacaoGeralP12'
                ]
            },
            {
                title: `${translate('referencia')} (Etapa 2)`,
                fields: ['referencia']
            },
            {
                title: `${translate('resultadosRealizacaoCompetencia')} (Etapa 3)`,
                fields: ['resultadosRealizacoesCompetencias']
            },
            {
                title: `${translate('historicoDeCarreira')} (Etapa 4)`,
                subSections: [
                    {
                        title: translate('pontosFortesTitulo'),
                        fields: [
                            'analiseSwotForteP1', 'analiseSwotForteP2', 'analiseSwotForteP3',
                            'analiseSwotForteP4', 'analiseSwotForteP5', 'analiseSwotForteP6', 'analiseSwotForteP7'
                        ]
                    },
                    {
                        title: translate('pontosFracosTitulo'),
                        fields: [
                            'analiseSwotFracoP1', 'analiseSwotFracoP2', 'analiseSwotFracoP3',
                            'analiseSwotFracoP4', 'analiseSwotFracoP5', 'analiseSwotFracoP6',
                            'analiseSwotFracoP7', 'analiseSwotFracoP8'
                        ]
                    },
                    {
                        title: translate('oportunidadesTitulo'),
                        fields: [
                            'analiseSwotOportunidadeP1', 'analiseSwotOportunidadeP2', 'analiseSwotOportunidadeP3',
                            'analiseSwotOportunidadeP4', 'analiseSwotOportunidadeP5'
                        ]
                    },
                    {
                        title: translate('ameacasTitulo'),
                        fields: [
                            'analiseSwotAmeacaP1', 'analiseSwotAmeacaP2',
                            'analiseSwotAmeacaP3', 'analiseSwotAmeacaP4',
                            'analiseSwotAmeacaP5', 'analiseSwotAmeacaP6'
                        ]
                    }
                ],
                fields: []
            },
            {
                title: `${translate('reflexaoDeCarreriaTitulo')} (Etapa 5)`,
                fields: [
                    'reflexaoDeCarreiraP1', 'reflexaoDeCarreiraP2', 'reflexaoDeCarreiraP3',
                    'reflexaoDeCarreiraP4', 'reflexaoDeCarreiraP5', 'reflexaoDeCarreiraP6',
                    'reflexaoDeCarreiraP7', 'reflexaoDeCarreiraP8', 'reflexaoDeCarreiraP9'
                ]
            },
            {
                title: `${translate('estiloDeLiderancaTitulo')} (Etapa 6)`,
                fields: [
                    'estiloDeLiderancaP1', 'estiloDeLiderancaP2', 'estiloDeLiderancaP3'
                ]
            }
        ];

        // Mapeamento de IDs de campos para chaves de tradução específicas
        const translationKeys: Record<string, string> = {
            // Informações Gerais (Etapa 1)
            'informacaoGeralP1': 'informacoesGeraisP1',
            'informacaoGeralP2': 'informacoesGeraisP2',
            'idFaixaRemuneracao': 'informacoesGeraisP3',
            'informacaoGeralP3': 'informacoesGeraisP4',
            'informacaoGeralP4': 'informacoesGeraisP5',
            'informacaoGeralP5': 'informacoesGeraisP6',
            'informacaoGeralP6': 'informacoesGeraisP7',
            'informacaoGeralP7': 'informacoesGeraisP8',
            'informacaoGeralP8': 'informacoesGeraisP9',
            'informacaoGeralP9': 'informacoesGeraisP10',
            'informacaoGeralP10': 'informacoesGeraisP11',
            'informacaoGeralP11': 'informacoesGeraisP12',
            'informacaoGeralP12': 'informacoesGeraisP13',

            // Referências (Etapa 2)
            'referencia': 'referencia',

            // Resultados, Realizações e Competências (Etapa 3)
            'resultadosRealizacoesCompetencias': 'resultadosRealizacaoCompetencia',

            // Histórico de Carreira - Análise SWOT - Pontos Fortes (Etapa 4)
            'analiseSwotForteP1': 'pontosFortesP1',
            'analiseSwotForteP2': 'pontosFortesP2',
            'analiseSwotForteP3': 'pontosFortesP3',
            'analiseSwotForteP4': 'pontosFortesP4',
            'analiseSwotForteP5': 'pontosFortesP5',
            'analiseSwotForteP6': 'pontosFortesP6',
            'analiseSwotForteP7': 'pontosFortesP7',

            // Histórico de Carreira - Análise SWOT - Fracos (Etapa 4)
            'analiseSwotFracoP1': 'pontosFracosP1',
            'analiseSwotFracoP2': 'pontosFracosP2',
            'analiseSwotFracoP3': 'pontosFracosP3',
            'analiseSwotFracoP4': 'pontosFracosP4',
            'analiseSwotFracoP5': 'pontosFracosP5',
            'analiseSwotFracoP6': 'pontosFracosP6',
            'analiseSwotFracoP7': 'pontosFracosP7',
            'analiseSwotFracoP8': 'pontosFracosP8',

            // Histórico de Carreira - Análise SWOT - Oportunidades (Etapa 4)
            'analiseSwotOportunidadeP1': 'oportunidadesP1',
            'analiseSwotOportunidadeP2': 'oportunidadesP2',
            'analiseSwotOportunidadeP3': 'oportunidadesP3',
            'analiseSwotOportunidadeP4': 'oportunidadesP4',
            'analiseSwotOportunidadeP5': 'oportunidadesP5',

            // Histórico de Carreira - Análise SWOT - Ameaças (Etapa 4)
            'analiseSwotAmeacaP1': 'ameacasP1',
            'analiseSwotAmeacaP2': 'ameacasP2',
            'analiseSwotAmeacaP3': 'ameacasP3',
            'analiseSwotAmeacaP4': 'ameacasP4',
            'analiseSwotAmeacaP5': 'ameacasP5',
            'analiseSwotAmeacaP6': 'ameacasP6',

            // Reflexão de Carreira (Etapa 5)
            'reflexaoDeCarreiraP1': 'reflexaoDeCarreriaP1',
            'reflexaoDeCarreiraP2': 'reflexaoDeCarreriaP2',
            'reflexaoDeCarreiraP3': 'reflexaoDeCarreriaP3',
            'reflexaoDeCarreiraP4': 'reflexaoDeCarreriaP4',
            'reflexaoDeCarreiraP5': 'reflexaoDeCarreriaP5',
            'reflexaoDeCarreiraP6': 'reflexaoDeCarreriaP6',
            'reflexaoDeCarreiraP7': 'reflexaoDeCarreriaP7',
            'reflexaoDeCarreiraP8': 'reflexaoDeCarreriaP8',
            'reflexaoDeCarreiraP9': 'reflexaoDeCarreriaP9',

            // Estilo de Liderança (Etapa 6)
            'estiloDeLiderancaP1': 'estiloDeLiderancaP1',
            'estiloDeLiderancaP2': 'estiloDeLiderancaP2',
            'estiloDeLiderancaP3': 'estiloDeLiderancaP3'
        };

        // Processar cada seção
        sections.forEach((section, index) => {
            // Incluir todas as seções, mesmo sem dados preenchidos

            // Adicionar nova página para cada seção (exceto a primeira)
            if (index > 0) {
                pdf.addPage();
                // Adicionar elementos visuais à nova página
                addPageDecorations();
                yPosition = 40; // Ajustar para começar abaixo do cabeçalho
            }

            // Adicionar título da seção (centralizado)
            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(subtitleSize);
            pdf.text(section.title, pageWidth / 2, yPosition, { align: 'center' });
            yPosition += subtitleSize * 0.5;

            // Adicionar linha separadora
            pdf.setDrawColor(0);
            pdf.line(margin, yPosition + 2, pageWidth - margin, yPosition + 2);
            yPosition += lineHeight * 1.5;

            // Tratamento especial para a seção de Resultados, Realizações e Competências (Etapa 3)
            if (section.title.includes('(Etapa 3)') && formData?.resultadosRealizacoesCompetencias && Array.isArray(formData.resultadosRealizacoesCompetencias) && formData.resultadosRealizacoesCompetencias.length > 0) {
                // Armazenar referência segura ao array
                const resultados = formData.resultadosRealizacoesCompetencias;
                
                // Adicionar cada item no formato de perguntas e respostas
                formData.resultadosRealizacoesCompetencias.forEach((item, index) => {
                    // Adicionar número do item
                    pdf.setFont('helvetica', 'bold');
                    pdf.setFontSize(12);
                    pdf.text(`Item ${index + 1}`, margin, yPosition);
                    yPosition += lineHeight;

                    // Função para adicionar uma pergunta e resposta
                    const addQA = (question: string, answer: string) => {
                        // Pergunta
                        pdf.setFont('helvetica', 'bold');
                        pdf.setFontSize(10);
                        pdf.text(question, margin + 10, yPosition);
                        yPosition += lineHeight;

                        // Resposta
                        pdf.setFont('helvetica', 'normal');
                        pdf.setFontSize(10);
                        const lines = pdf.splitTextToSize(answer || '(Não preenchido)', pageWidth - margin * 2 - 20);
                        
                        // Verificar espaço disponível na página atual
                        const availableHeight = pageHeight - margin - 10 - yPosition;
                        const linesPerPage = Math.floor(availableHeight / 4.5);
                        
                        if (lines.length > linesPerPage) {
                            // Renderizar o que cabe na página atual
                            const currentPageLines = lines.slice(0, linesPerPage);
                            pdf.text(currentPageLines, margin + 20, yPosition);
                            
                            // Continuar na próxima página
                            pdf.addPage();
                            addPageDecorations();
                            yPosition = 40;
                            
                            // Renderizar o restante do texto
                            pdf.setFont('helvetica', 'normal');
                            pdf.setFontSize(10);
                            const remainingLines = lines.slice(linesPerPage);
                            pdf.text(remainingLines, margin + 20, yPosition);
                            yPosition += remainingLines.length * 4.5;
                        } else {
                            // Renderizar todo o texto na página atual
                            pdf.text(lines, margin + 20, yPosition);
                            yPosition += lines.length * 4.5;
                        }
                        
                        yPosition += lineHeight * 0.5; // Espaço após a resposta
                    };

                    // Adicionar cada campo
                    addQA(translate('problemaDesafioTitulo') + ':', item.problemaDesafio || '');
                    addQA(translate('acaoTituloP1') + ':', item.acao || '');
                    addQA(translate('resultadosTitulo') + ':', item.resultado || '');
                    addQA(translate('sinteseTitulo') + ':', item.sintese || '');
                    
                    // Competências
                    const competencias = item.tbCompetencias && item.tbCompetencias.length > 0 ?
                        item.tbCompetencias.map((comp: any) => comp.descricao).join(', ') :
                        '';
                    addQA(translate('CompetenciaTitulo') + ':', competencias);

                    // Adicionar linha separadora entre itens (exceto o último)
                    if (index < resultados.length - 1) {
                        yPosition += lineHeight;
                        pdf.setDrawColor(200, 200, 200);
                        pdf.line(margin, yPosition - lineHeight/2, pageWidth - margin, yPosition - lineHeight/2);
                        yPosition += lineHeight;
                    }
                });
                
                // Adicionar espaço após a seção
                yPosition += lineHeight;
                pdf.setFont('helvetica', 'normal');
                pdf.setFontSize(answerSize);
                pdf.setTextColor(0, 0, 0);

                // Adicionar espaço após a tabela
                yPosition += lineHeight * 1.5;

                // Pular o processamento normal dos campos para esta seção
                return;
            }

            // Verificar se a seção tem subseções
            if (section.subSections && section.subSections.length > 0) {
                // Processar cada subseção
                section.subSections.forEach((subSection, subIndex) => {
                    // Adicionar nova página para cada subseção (exceto a primeira da seção)
                    if (subIndex > 0) {
                        pdf.addPage();
                        // Adicionar elementos visuais à nova página
                        addPageDecorations();
                        yPosition = 40; // Ajustar para começar abaixo do cabeçalho
                        
                        // Adicionar título da seção principal novamente (menor e mais discreto)
                        pdf.setFont('helvetica', 'italic');
                        pdf.setFontSize(subtitleSize - 2);
                        pdf.setTextColor(100, 100, 100);
                        pdf.text(section.title, pageWidth / 2, yPosition, { align: 'center' });
                        yPosition += (subtitleSize - 2) * 0.5 + lineHeight;
                        pdf.setTextColor(0, 0, 0); // Restaurar cor do texto
                    }
                    
                    // Adicionar título da subseção (centralizado)
                    pdf.setFont('helvetica', 'bold');
                    pdf.setFontSize(14);
                    pdf.text(subSection.title, pageWidth / 2, yPosition, { align: 'center' });
                    yPosition += 14 * 0.5;
                    yPosition += lineHeight * 0.5;

                    // Adicionar linha separadora leve para a subseção
                    pdf.setDrawColor(150);
                    pdf.line(margin + 10, yPosition + 1, pageWidth - margin - 10, yPosition + 1);
                    yPosition += lineHeight * 1;

                    // Processar campos da subseção
                    subSection.fields.forEach(field => {
                        const value = formData[field as keyof IAnalisePerfil];

                        // Verificar se precisa de nova página
                        yPosition = checkForNewPage(yPosition, questionSize + answerSize + lineHeight * 3);

                        // Obter o título da pergunta via translate ou formatando o nome do campo
                        let questionTitle = '';

                        // Resto do código para processar o campo...
                        try {
                            // Tentar usar a chave de tradução específica, se existir
                            if (field in translationKeys) {
                                questionTitle = translate(translationKeys[field]);
                            }

                            // Se não houver chave específica ou a tradução falhar, tentar o ID do campo
                            if (!questionTitle || questionTitle === translationKeys[field]) {
                                questionTitle = translate(field);
                            }

                            // Se ainda não tiver tradução, usar o formato do nome do campo
                            if (!questionTitle || questionTitle === field) {
                                questionTitle = formatFieldName(field);
                            }
                        } catch {
                            // Se falhar, usar o formato do nome do campo
                            questionTitle = formatFieldName(field);
                        }

                        // Adicionar nome do campo (pergunta) com suporte a múltiplas páginas
                        yPosition = processMultiPageText(questionTitle, margin, yPosition, pageWidth - (margin * 2), questionSize, true);
                        yPosition += lineHeight * 0.5;

                        // Adicionar valor do campo (resposta)
                        let valueText = '';

                        if (value === undefined || value === null || value === '') {
                            valueText = '(Não preenchido)';
                        } else if (Array.isArray(value)) {
                            // Tratar arrays (outros tipos)
                            if (value.length === 0) {
                                valueText = '(Lista vazia)';
                            } else {
                                valueText = value.map((item, i) => `Item ${i + 1}: ${JSON.stringify(item)}`).join('\n');
                            }
                        } else {
                            valueText = String(value);
                        }

                        // Usar a função que suporta texto em múltiplas páginas
                        yPosition = processMultiPageText(valueText, margin + 5, yPosition, pageWidth - (margin * 2) - 5, answerSize);
                        yPosition += lineHeight * 1.5;
                    });

                    // Adicionar espaço entre subseções
                    yPosition += lineHeight * 1;
                });
            } else {
                // Processar campos desta seção (sem subseções)
                section.fields.forEach(field => {
                    const value = formData[field as keyof IAnalisePerfil];

                    // Verificar se precisa de nova página
                    yPosition = checkForNewPage(yPosition, questionSize + answerSize + lineHeight * 3);

                    // Obter o título da pergunta via translate ou formatando o nome do campo
                    let questionTitle = '';

                    try {
                        // Tentar usar a chave de tradução específica, se existir
                        if (field in translationKeys) {
                            questionTitle = translate(translationKeys[field]);
                        }

                        // Se não houver chave específica ou a tradução falhar, tentar o ID do campo
                        if (!questionTitle || questionTitle === translationKeys[field]) {
                            questionTitle = translate(field);
                        }

                        // Se ainda não tiver tradução, usar o formato do nome do campo
                        if (!questionTitle || questionTitle === field) {
                            questionTitle = formatFieldName(field);
                        }
                    } catch {
                        // Se falhar, usar o formato do nome do campo
                        questionTitle = formatFieldName(field);
                    }

                    // Adicionar nome do campo (pergunta) com suporte a múltiplas páginas
                    yPosition = processMultiPageText(questionTitle, margin, yPosition, pageWidth - (margin * 2), questionSize, true);
                    yPosition += lineHeight * 0.5;

                    // Adicionar valor do campo (resposta)
                    let valueText = '';

                    if (value === undefined || value === null || value === '') {
                        // Tratamento especial para idFaixaRemuneracao quando estiver vazio
                        if (field === 'idFaixaRemuneracao') {
                            // Tentar buscar o valor do idFaixaRemuneracao diretamente do formData
                            const idFaixaRemuneracao = formData.idFaixaRemuneracao;
                            if (idFaixaRemuneracao !== undefined && typeof idFaixaRemuneracao === 'number') {
                                // Buscar o texto da faixa salarial pelo ID
                                const faixaSalarial = faixasSalariais.find((f: any) => f.id === idFaixaRemuneracao);
                                if (faixaSalarial) {
                                    valueText = faixaSalarial.nome || String(idFaixaRemuneracao);
                                } else {
                                    valueText = `Faixa Salarial ID: ${idFaixaRemuneracao}`;
                                }
                            } else {
                                valueText = '(Faixa salarial não preenchida)';
                            }
                        } else {
                            valueText = '(Não preenchido)';
                        }
                    } else if (field === 'idFaixaRemuneracao' && typeof value === 'number') {
                        // Buscar o texto da faixa salarial pelo ID
                        const faixaSalarial = faixasSalariais.find((f: any) => f.id === value);
                        if (faixaSalarial) {
                            valueText = faixaSalarial.nome || String(value);
                        } else {
                            valueText = `Faixa Salarial ID: ${value}`;
                        }
                    } else if (Array.isArray(value)) {
                        // Tratar arrays (como resultadosRealizacoesCompetencias)
                        if (value.length === 0) {
                            valueText = '(Lista vazia)';
                        } else {
                            valueText = value.map((item, i) => `Item ${i + 1}: ${JSON.stringify(item)}`).join('\n');
                        }
                    } else {
                        valueText = String(value);
                    }

                    // Usar a função que suporta texto em múltiplas páginas
                    yPosition = processMultiPageText(valueText, margin + 5, yPosition, pageWidth - (margin * 2) - 5, answerSize);
                    yPosition += lineHeight * 1.5;
                })
            }

            // Renderizar a tabela SWOT no final da seção Histórico de Carreira (Etapa 4)
            if (section.title.includes('(Etapa 4)')) {
                // Considerar a margem inferior para não ultrapassar as bordas decorativas
                const bottomMargin = margin + 10;
                
                // Verificar se há espaço suficiente para a tabela na página atual
                // A tabela SWOT precisa de aproximadamente 140 pontos de altura
                const tabelaSwotAltura = 140;

                // Se não houver espaço suficiente, adicionar nova página
                if (yPosition + tabelaSwotAltura > pageHeight - bottomMargin) {
                    pdf.addPage();
                    addPageDecorations();
                    yPosition = margin + 30; // Ajustar para começar abaixo do cabeçalho
                }

                // Adicionar espaço antes da tabela
                yPosition += lineHeight * 2;

                // Definir altura da tabela - ajustada para ser mais responsiva
                const colWidth = (pageWidth - margin * 2) / 2; // Largura de cada coluna
                
                // Calcular alturas com base no conteúdo
                const forcasContent = formData.analiseSwotForcaOrigem || '(Não preenchido)';
                const fraquezasContent = formData.analiseSwotFraquezaOrigem || '(Não preenchido)';
                const oportunidadesContent = formData.analiseSwotOportunidadeOrigem || '(Não preenchido)';
                const ameacasContent = formData.analiseSwotAmeacaOrigem || '(Não preenchido)';
                
                // Calcular a altura necessária para cada quadrante
                const forcasLines = pdf.splitTextToSize(forcasContent, colWidth - 20).length;
                const fraquezasLines = pdf.splitTextToSize(fraquezasContent, colWidth - 20).length;
                const oportunidadesLines = pdf.splitTextToSize(oportunidadesContent, colWidth - 20).length;
                const ameacasLines = pdf.splitTextToSize(ameacasContent, colWidth - 20).length;
                
                // Calcular a altura para cada linha da tabela SWOT
                const linha1Height = Math.max(forcasLines, fraquezasLines) * 4 + 30; // 30 pontos para cabeçalhos e margens
                const linha2Height = Math.max(oportunidadesLines, ameacasLines) * 4 + 30;
                
                // Verificar se a primeira linha cabe na página atual
                if (yPosition + linha1Height + 35 > pageHeight - bottomMargin) { // 35 para cabeçalhos
                    pdf.addPage();
                    addPageDecorations();
                    yPosition = margin + 30;
                }

                // Adicionar cabeçalhos da tabela
                // Cabeçalho Útil
                pdf.setFillColor(200, 220, 255); // Azul claro
                pdf.setTextColor(0, 0, 0);
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(12);
                pdf.rect(margin, yPosition, colWidth, 15, 'F');
                pdf.text(translate('util') || 'Útil', margin + colWidth / 2, yPosition + 10, { align: 'center' });

                // Cabeçalho Prejudicial
                pdf.setFillColor(255, 200, 200); // Vermelho claro
                pdf.rect(margin + colWidth, yPosition, colWidth, 15, 'F');
                pdf.text(translate('prejudicial') || 'Prejudicial', margin + colWidth + colWidth / 2, yPosition + 10, { align: 'center' });

                yPosition += 15; // Avançar para a primeira linha da tabela

                // Primeira linha - Forças e Fraquezas
                // Cabeçalho Forças
                pdf.setFillColor(88, 139, 255); // Azul
                pdf.setTextColor(255, 255, 255);
                pdf.rect(margin, yPosition, colWidth, 20, 'F');
                pdf.text(translate('forcas') || 'Forças', margin + colWidth / 2, yPosition + 12, { align: 'center' });

                // Cabeçalho Fraquezas
                pdf.setFillColor(247, 95, 37); // Laranja
                pdf.rect(margin + colWidth, yPosition, colWidth, 20, 'F');
                pdf.text(translate('fraquezas') || 'Fraquezas', margin + colWidth + colWidth / 2, yPosition + 12, { align: 'center' });

                yPosition += 20; // Avançar para o conteúdo da primeira linha

                // Conteúdo Forças
                pdf.setFillColor(240, 240, 240); // Cinza claro
                pdf.setTextColor(0, 0, 0);
                pdf.setFont('helvetica', 'normal');
                pdf.setFontSize(10);
                pdf.rect(margin, yPosition, colWidth, linha1Height - 20, 'F');

                // Adicionar conteúdo das Forças usando a função que suporta múltiplas páginas
                processMultiPageText(forcasContent, margin + 10, yPosition + 10, colWidth - 20, 10);

                // Conteúdo Fraquezas
                pdf.setFillColor(240, 240, 240); // Cinza claro
                pdf.rect(margin + colWidth, yPosition, colWidth, linha1Height - 20, 'F');

                // Adicionar conteúdo das Fraquezas usando a função que suporta múltiplas páginas
                processMultiPageText(fraquezasContent, margin + colWidth + 10, yPosition + 10, colWidth - 20, 10);

                yPosition += linha1Height - 20; // Avançar para a segunda linha da tabela
                
                // Verificar se a segunda linha cabe na página atual
                if (yPosition + linha2Height + 20 > pageHeight - bottomMargin) {
                    pdf.addPage();
                    addPageDecorations();
                    yPosition = margin + 30;
                    
                    // Adicionar título para continuidade
                    pdf.setFont('helvetica', 'italic');
                    pdf.setFontSize(subtitleSize - 2);
                    pdf.setTextColor(100, 100, 100);
                    pdf.text('Análise SWOT (continuação)', pageWidth / 2, yPosition, { align: 'center' });
                    yPosition += 15;
                    pdf.setTextColor(0, 0, 0);
                }

                // Segunda linha - Oportunidades e Ameaças
                // Cabeçalho Oportunidades
                pdf.setFillColor(77, 189, 41); // Verde
                pdf.setTextColor(255, 255, 255);
                pdf.setFont('helvetica', 'bold');
                pdf.rect(margin, yPosition, colWidth, 20, 'F');
                pdf.text(translate('oportunidades') || 'Oportunidades', margin + colWidth / 2, yPosition + 12, { align: 'center' });

                // Cabeçalho Ameaças
                pdf.setFillColor(255, 179, 41); // Amarelo
                pdf.rect(margin + colWidth, yPosition, colWidth, 20, 'F');
                pdf.text(translate('ameacas') || 'Ameaças', margin + colWidth + colWidth / 2, yPosition + 12, { align: 'center' });

                yPosition += 20; // Avançar para o conteúdo da segunda linha

                // Conteúdo Oportunidades
                pdf.setFillColor(240, 240, 240); // Cinza claro
                pdf.setTextColor(0, 0, 0);
                pdf.setFont('helvetica', 'normal');
                pdf.setFontSize(10);
                pdf.rect(margin, yPosition, colWidth, linha2Height - 20, 'F');

                // Adicionar conteúdo das Oportunidades usando a função que suporta múltiplas páginas
                processMultiPageText(oportunidadesContent, margin + 10, yPosition + 10, colWidth - 20, 10);

                // Conteúdo Ameaças
                pdf.setFillColor(240, 240, 240); // Cinza claro
                pdf.rect(margin + colWidth, yPosition, colWidth, linha2Height - 20, 'F');

                // Adicionar conteúdo das Ameaças usando a função que suporta múltiplas páginas
                processMultiPageText(ameacasContent, margin + colWidth + 10, yPosition + 10, colWidth - 20, 10);

                yPosition += linha2Height - 20; // Avançar para depois da tabela

                // Adicionar espaço após a tabela
                yPosition += lineHeight * 2;

                // Restaurar configurações de fonte para o resto do documento
                pdf.setFont('helvetica', 'normal');
                pdf.setFontSize(answerSize);
                pdf.setTextColor(0, 0, 0);
            }
        });

        // A tabela SWOT será renderizada dentro do processamento da seção 4
        // Salvar o PDF
        pdf.save(`${translate('analiseDePerfilPlanejamentoCarreira')}.pdf`);

        toast.success(translate('pdfGeradoComSucesso'));
    } catch (error) {
        console.error('Erro ao gerar PDF:', error);
        toast.error(translate('erroAoGerarPdf'));
    }
};